import { Timeline as TimelineIcon } from "@mui/icons-material";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import ReactECharts from "echarts-for-react";
import AnalyticsCard from "./AnalyticsCard";
import { useMemo, useState } from "react";

const AnalyticsTimeSeries = ({ TimeSeries, title }) => {
  const [selectedPeriod, setSelectedPeriod] = useState("monthly");

  const handleChangePeriod = (event, newPeriod) => {
    if (newPeriod) setSelectedPeriod(newPeriod);
  };

  const chartData = useMemo(() => {
    const seriesData = TimeSeries?.[selectedPeriod] || [];
    return {
      xAxisData: seriesData.map((item) => item.period),
      leadsData: seriesData.map((item) => item.total_count),
    };
  }, [selectedPeriod, TimeSeries]);

  //   const chartData = useMemo(() => {
  //     let seriesData = TimeSeries?.[selectedPeriod] || [];

  //     if (selectedPeriod === "monthly") {
  //       const currentYear = new Date().getFullYear().toString();
  //       seriesData = seriesData.filter((item) =>
  //         item.period.startsWith(currentYear)
  //       );
  //     }

  //     return {
  //       xAxisData: seriesData.map((item) => item.period),
  //       leadsData: seriesData.map((item) => item.total_count),
  //     };
  //   }, [selectedPeriod, TimeSeries]);

  const option = useMemo(
    () => ({
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333" },
        formatter: (params) => {
          const { name, value } = params[0];
          return `<b>${name}</b><br/>Leads: ${value}`;
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "12%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: chartData.xAxisData,
        axisLabel: {
          fontSize: 10,
          color: "#555",
          margin: 10,
          align: "center",
        },
        boundaryGap: false,
      },
      yAxis: {
        type: "value",
        axisLabel: { color: "#555" },
        splitLine: { lineStyle: { color: "#eee" } },
      },
      series: [
        {
          data: chartData.leadsData,
          type: "line",
          smooth: true,
          showSymbol: false,
          lineStyle: {
            color: "#0ea5e9",
            width: 2.5,
          },
          areaStyle: {
            color: "rgba(14,165,233,0.15)",
          },
        },
      ],
      toolbox: {
        feature: {
          saveAsImage: { title: "Download" },
        },
        right: 10,
      },
    }),
    [chartData, selectedPeriod]
  );

  return (
    <div>
      <AnalyticsCard
        title={title}
        icon={TimelineIcon}
        color="#14b8a6"
        sx={{
          height: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            flexWrap: "wrap",
            px: 2,
            py: 1.5,
            borderBottom: "1px solid #f0f0f0",
            background: "linear-gradient(to right, #f0fdfa, #ecfeff)",
            borderRadius: "12px",
            mb: 1,
            gap: 2,
          }}
        >
          <Box sx={{ width: { xs: "100%", sm: "auto" } }}>
            <ToggleButtonGroup
              value={selectedPeriod}
              exclusive
              onChange={handleChangePeriod}
              size="small"
              sx={{
                backgroundColor: "#f9fafb",
                borderRadius: "30px",
                p: 0.3,
                "& .MuiToggleButton-root": {
                  textTransform: "none",
                  fontSize: "13px",
                  fontWeight: 600,
                  border: "none",
                  borderRadius: "20px",
                  color: "#4b5563",
                  px: 2,
                  "&.Mui-selected": {
                    backgroundColor: "#14b8a6",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#0d9488" },
                  },
                  "&:hover": { backgroundColor: "#e5e7eb" },
                },
              }}
            >
              <ToggleButton value="daily">Daily</ToggleButton>
              <ToggleButton value="monthly">Monthly</ToggleButton>
              <ToggleButton value="yearly">Yearly</ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Box
            sx={{
              width: { xs: "100%", sm: "auto" },
              textAlign: { xs: "left", sm: "right" },
              pr: { sm: 1 },
              pt: { xs: 1, sm: 0 },
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: "#14b8a6", lineHeight: 1.2 }}
            >
              {chartData.leadsData
                ?.reduce((a, b) => a + b, 0)
                ?.toLocaleString() || 0}
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "#666", fontWeight: 500 }}
            >
              Total Leads ({selectedPeriod})
            </Typography>
          </Box>
        </Box>

        {/* Chart */}
        <ReactECharts
          option={option}
          style={{
            height: "350px",
            width: "100%",
            marginTop: "-5px",
            marginBottom: "-30px",
          }}
          notMerge={true}
          lazyUpdate={true}
        />
      </AnalyticsCard>
    </div>
  );
};

export default AnalyticsTimeSeries;
